export default {
  shared: {
    appVersion: "Versión de la app",
    brand: "Marca",
  },
  assignBeforePairing:
    "Asigne este dispositivo a una estructura antes de vincular un lector",
  deviceRevoked: "Dispositivo revocado",
  deviceReactivated: "Dispositivo reactivado",
  deviceShelved: "Dispositivo en almacén",
  deviceUnshelved: "Dispositivo de nuevo en uso",
  credentialsRegenerated: "Credenciales regeneradas",
  kioskAssigned: "Dispositivo asignado correctamente",
  readerUpdated: "Lector actualizado",
  deviceRenamed: "Habitación actualizada",
  changeRoomTitle: "Cambiar habitación",
  addRoomTitle: "Añadir habitación",
  changeRoomCurrentLabel: "Habitación actual",
  changeRoomNewLabel: "Nuevo nombre de habitación",
  changeRoomPlaceholder: "p. ej. 231H",
  changeRoomNoRoom: "Sin habitación",
  changeRoomUnchanged: "Introduzca un nombre distinto para continuar",
  changeRoomConfirm: "Continuar",
  changeRoomRemove: "Quitar habitación",
  deviceGoogleAccountUpdated: "Cuenta Google actualizada",
  deviceNotesUpdated: "Notas actualizadas",
  deviceInstalledOnUpdated: "Fecha de instalación actualizada",
  page: {
    kpiTotal: "Dispositivos activos",
    kpiTotalHint: "Sin contar los del almacén",
    kpiOnline: "En línea",
    kpiOnlineHint: "Telemetría completa en las últimas 3 h",
    kpiIncomplete: "Configuración incompleta",
    kpiIncompleteHint: "Falta vinculación, lector o estructura",
    kpiShelved: "En almacén",
    kpiShelvedHint: "Fuera de servicio",
    title: "Gestión de dispositivos",
    subtitle: "Gestione los dispositivos de las estructuras",
    newDevice: "Nuevo dispositivo",
    tabDevices: "Dispositivos",
    tabPresets: "Plantillas de dispositivo",
    searchPlaceholder: "Buscar por nombre, código, estructura u otro…",
    filterActiveLabel: "Activo",
    filterActiveAll: "Todos",
    filterActiveActive: "Activos",
    filterActiveInactive: "Inactivos",
    filterSetupLabel: "Configuración",
    filterSetupAll: "Todos",
    filterSetupComplete: "Completos",
    filterSetupIncomplete: "Requiere atención",
    filterSetupRevoked: "Revocados",
    filterShelvedLabel: "Almacén",
    filterShelvedAll: "Todos",
    filterShelvedInService: "En uso",
    filterShelvedOnly: "En almacén",
    filterTelemetryLabel: "Estado de telemetría",
    filterTelemetryAll: "Todos",
    filterTelemetryGray: "Sin vincular",
    filterTelemetryGreen: "Completa",
    filterTelemetryYellow: "Incompleta",
    filterTelemetryRed: "Sin datos (> 3 h)",
    filterAppVersionAny: "Cualquiera",
    filterAppVersionCount: "{{count}} seleccionadas",
    filterIncompleteMissingLabel: "Motivo",
    filterIncompleteMissingAny: "Cualquiera",
    filterIncompleteMissingCount: "{{count}} seleccionados",
    filterAttentionNoTelemetry: "Sin telemetría",
    filterAttentionOutdatedApp: "App desactualizada",
    filterMissingBinding: "Falta clave de software",
    filterMissingReader: "Falta lector",
    filterMissingStructure: "Falta estructura",
    telemetryTooltipGray: "Sin acceso o sin vincular",
    telemetryTooltipGreen: "Telemetría completa",
    telemetryTooltipYellow: "Telemetría incompleta",
    telemetryTooltipRed: "Sin telemetría (> 3 h)",
    alertLowBattery: "Batería baja ({{level}}%)",
    alertWifiWeak: "Señal Wi-Fi débil o nula",
    inUseWarningTitle: "Requiere atención",
    inUseWarningStaleTelemetry: "Sin telemetría en las últimas 24 horas",
    inUseWarningOutdatedAppVersion: "Versión de app anterior a {{version}}",
    inUseWarningDeviceLowBattery: "Batería de la tablet baja",
    inUseWarningReaderLowBattery: "Batería del lector baja",
    inUseWarningMissingReader: "Sin lector vinculado",
    inUseWarningMissingStructure: "Sin estructura asignada",
    inUseWarningMissingRoom: "Sin habitación configurada",
    inUseCheckTelemetry: "Telemetría",
    inUseCheckAppVersion: "Versión app",
    inUseCheckDeviceBattery: "Bat. tablet",
    inUseCheckReaderBattery: "Bat. lector",
    inUseCheckReader: "Lector",
    inUseCheckStructure: "Estructura",
    inUseCheckRoom: "Hab.",
    inUseCheckOk: "OK",
    inUseCheckUnknown: "Desconocido",
    setupBadgeIncomplete: "Incompleto",
    setupBadgeRevoked: "Revocado",
    setupBadgeIncompleteTooltipTitle: "Aún falta:",
    setupBadgeIncompleteTooltipDesc:
      "Este dispositivo no puede aceptar pagos hasta completar la configuración.",
    setupBadgeRevokedTooltip: "Este dispositivo ha sido revocado",
    setupMissingBinding: "Vinculación de clave de software",
    setupMissingBindingDesc:
      "La tablet debe iniciar sesión con su clave de software al menos una vez.",
    setupMissingPairing: "Vinculación del lector de pago",
    setupMissingPairingDesc:
      "Debe vincularse un lector de pago a esta tablet para procesar pagos con tarjeta.",
    setupMissingAssignment: "Asignación a estructura",
    setupMissingAssignmentDesc:
      "El dispositivo debe asignarse a una estructura de anfitrión.",
    colDevice: "Habitación",
    colSerial: "N/S",
    colGoogleAccount: "Cuenta Google",
    colFreekioskUnlock: "Desbloqueo FK",
    colReader: "Lector",
    colHouse: "Estructura",
    colLastTelemetry: "Última telemetría",
    colLastInteraction: "Última interacción",
    colInstalledOn: "Instalado el",
    colInUse: "En uso",
    colActions: "Acciones",
    selectRow: "Seleccionar {{name}}",
    selectAllFiltered: "Seleccionar los {{count}} filtrados",
    exportCsv: "Exportar CSV",
    emptySearch: "No hay dispositivos que coincidan con la búsqueda.",
    emptyDefault: "No hay dispositivos. Cree el primero para empezar.",
    readerPair: "Vincular",
    readerOpenTitle: "Ir al lector",
    readerUnpairTitle: "Desvincular lector",
    readerUnpairConfirm:
      "¿Desvincular este lector de la tablet? El emparejamiento con SumUp se conserva; los pagos permanecerán desactivados hasta que vuelvas a vincular.",
    readerUnpaired: "Lector desvinculado",
    houseOpenTitle: "Ir a la estructura",
    houseRemoveTitle: "Quitar estructura del dispositivo",
    houseRemoveConfirm:
      "¿Quitar «{{name}}» de este dispositivo? Quedará sin asignar.",
    houseRemoved: "Estructura eliminada",
    structureLeaveIntro:
      'Al salir de «{{name}}» se limpiará la ocupación activa de este tablet.',
    structureLeaveCurrentHeading:
      "Huéspedes actuales (fin de estancia, se guarda en el historial)",
    structureLeaveFutureHeading: "Huéspedes próximos (se eliminan por completo)",
    structureLeaveCurrentNote:
      "Las estancias actuales terminan ahora y permanecen en el historial de esta estructura.",
    structureLeaveFutureNote:
      "Las estancias próximas se eliminan y no se pueden restaurar.",
    structureLeaveEmpty: "No hay huéspedes actuales ni próximos en este tablet.",
    structureLeaveLoading: "Comprobando huéspedes…",
    assignLeaveIntro:
      'Este tablet deja «{{name}}». Se limpiará la ocupación activa antes de asignar la nueva estructura.',
    roomChangeTitle: "¿Cambiar habitación?",
    roomChangeIntro:
      "Este tablet tiene huéspedes actuales o próximos. Elija qué hacer con ellos.",
    roomChangeNewLabel: "Nueva habitación:",
    roomChangeCurrentHeading: "Huéspedes actuales",
    roomChangeFutureHeading: "Huéspedes próximos",
    roomChangeTransferHelp:
      "Transferir: mantener los huéspedes en este tablet con el nuevo nombre de habitación.",
    roomChangeDiscardHelp:
      "Descartar: finalizar huéspedes actuales (historial conservado) y eliminar próximas estancias.",
    roomChangeTransfer: "Transferir huéspedes",
    roomChangeDiscard: "Descartar ocupación",
    assign: "Asignar",
    moreActionsTitle: "Más acciones",
    regenerateConfirm:
      "¿Regenerar contraseña de «{{name}}»? Las sesiones del tablet existentes dejarán de ser válidas.",
    revokeConfirm:
      "¿Revocar las credenciales de «{{name}}»? El tablet se desconectará y no podrá volver a acceder hasta que lo reactives.",
    credentialModalTitle: "Credenciales regeneradas",
    credentialModalDesc:
      "La contraseña se ha regenerado. Guarde estas credenciales ahora: la contraseña solo se muestra una vez.",
    statusPartial: "Parcialmente configurado",
    assignModalTitle: "Asignar dispositivo",
    assignModalIntro: "Asigne {{name}} a un anfitrión y una estructura.",
    selectHostStep: "1) Seleccionar anfitrión",
    selectHouseStep: "2) Seleccionar estructura",
    searchHostsPlaceholder: "Buscar anfitriones…",
    searchHousesPlaceholder: "Buscar estructuras…",
    searchHousesDisabledPlaceholder: "Primero elija un anfitrión…",
    noHostsFound: "No se encontraron anfitriones.",
    pickHostForHouses: "Elija un anfitrión para ver sus estructuras.",
    noHousesFound: "No se encontraron estructuras.",
    noAddressSet: "Sin dirección",
    assignedDevicesLabel: "Dispositivos asignados:",
    assignSubmit: "Asignar",
    otherInfoTitle: "Más datos del dispositivo",
    fieldRoomName: "Habitación",
    fieldKioskCode: "Código de dispositivo",
    fieldSerialNumber: "Número de serie",
    fieldSoftwareId: "ID de software",
    fieldGoogleAccount: "Cuenta Google",
    fieldReaderId: "ID del lector",
    fieldDisplayInches: "Pulgadas de pantalla",
    fieldResolution: "Resolución",
    fieldAndroidVersion: "Versión de Android",
    valueAppVersionUnknown: "Desconocida",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    editNotesTitle: "Notas",
    editInstalledOnTitle: "Fecha de instalación",
    insertInstalledOn: "Insertar fecha",
    notesPlaceholder: "Añadir una nota…",
    fieldLastTelemetryReport: "Última telemetría recibida",
    sectionTelemetryData: "Datos de telemetría",
    sectionTelemetryDeviceStatus: "Estado del dispositivo (FreeKiosk)",
    sectionTelemetryGpsLocation: "Ubicación (GPS del dispositivo)",
    valueTelemetryNever: "Nunca",
    valueTelemetryEmpty: "Sin datos por ahora",
    fieldHouse: "Estructura",
    valueUnbound: "Sin vincular",
    valueNotPaired: "Sin vincular",
    valueUnassigned: "Sin asignar",
    menuRegenerateCredentials: "Regenerar credenciales",
    menuRevokeDevice: "Revocar credenciales",
    menuReactivateDevice: "Reactivar credenciales",
    menuNotes: "Notas",
    menuManagePresences: "Gestionar huéspedes",
    menuOtherInfo: "Más información",
    changeRoomTitle: "Cambiar habitación",
    renameDeviceTitle: "Cambiar habitación",
    roomNamePlaceholder: "Nombre de habitación",
    roomNameEmpty: "El nombre de habitación no puede estar vacío",
    editGoogleAccountTitle: "Editar cuenta Google",
    telemetryBattery: "Batería",
    telemetryWifi: "Señal WiFi",
    telemetryAudio: "Volumen de audio",
    telemetryStorage: "Almacenamiento usado",
    telemetryMemory: "RAM usada",
    telemetryUnavailable: "-",
    telemetryDataAge: "Datos de {{age}}",
  },
  createModal: {
    titleCreate: "Crear nuevo dispositivo",
    titleCreated: "¡Dispositivo creado!",
    hardwareIdLabel: "ID de hardware (S/N o IMEI)",
    hardwareIdPlaceholder: "p. ej. 359881234567890",
    hardwareIdRequired: "Introduce un ID de hardware (S/N o IMEI)",
    googleAccountLabel: "Cuenta de Google",
    googleAccountPlaceholder: "p. ej. tablet@empresa.com",
    googleAccountRequired: "Introduce el email de la cuenta de Google",
    roomNameLabel: "Habitación (opcional)",
    roomNamePlaceholder: "p. ej. 231H",
    presetSelectorTitle: "Elige una plantilla de dispositivo",
    presetsEmpty:
      "No hay plantillas. Puedes crear una desde la página de plantillas de dispositivo o usar el modo manual abajo.",
    presetCardSpecs: 'Android {{version}} • {{resolution}} • {{inches}}"',
    presetRequired:
      "Selecciona una plantilla de dispositivo o pasa al modo manual",
    manualToggle: "Introducir los datos del hardware manualmente",
    brandPlaceholder: "p. ej. Samsung",
    androidVersionLabel: "Versión de Android",
    androidVersionPlaceholder: "p. ej. 14",
    resolutionLabel: "Resolución de pantalla",
    resolutionPlaceholder: "p. ej. 1920x1200",
    inchesLabel: "Pulgadas de pantalla",
    inchesPlaceholder: "p. ej. 10.1",
    inchesInvalid: "Las pulgadas deben ser un número válido",
    submit: "Crear dispositivo",
    successTitle: "¡Dispositivo creado correctamente!",
    successDescription:
      "Usa estas credenciales para iniciar sesión desde la tablet. No volverán a mostrarse.",
    deviceNameLabel: "Habitación",
    modelLabel: "Modelo",
    modelPlaceholder: "p. ej. Tab A9",
    kioskCodeLabel: "Código de dispositivo",
    passwordLabel: "Contraseña",
    qrHelp:
      "Escanea este QR desde la pantalla de inicio de sesión de la tablet para rellenar las credenciales automáticamente.",
    importantLabel: "Importante:",
    importantDescription:
      "Guarda estas credenciales ahora. Cualquiera que escanee el QR podrá iniciar sesión hasta que regeneres la contraseña.",
  },
  presets: {
    validationRequired: "Todos los campos son obligatorios",
    validationDisplayInches:
      "Las pulgadas de pantalla deben ser un número válido mayor que cero",
    created: "Plantilla creada",
    updated: "Plantilla actualizada",
    deleted: "Plantilla eliminada",
    deleteConfirm: "¿Eliminar la plantilla «{{name}}»?",
    brandPlaceholder: "Marca (p. ej. TCL)",
    modelPlaceholder: "Modelo (p. ej. TAB 10L)",
    androidVersionPlaceholder: "Versión de Android (p. ej. 15)",
    resolutionPlaceholder: "Resolución (p. ej. 800x1280)",
    inchesPlaceholder: "Pulgadas (p. ej. 10.1)",
    save: "Guardar plantilla",
    add: "Añadir plantilla",
    colModel: "Modelo",
    colAndroid: "Android",
    colResolution: "Resolución",
    colInches: "Pulgadas",
    inchesValue: "{{inches}}″",
    colActions: "Acciones",
    empty: "Aún no hay plantillas.",
    editTitle: "Editar plantilla",
    deleteTitle: "Eliminar plantilla",
  },
} as const;
